export default () => {
	let iframeVideos = document.querySelectorAll('.js-if-video');
	iframeVideos.forEach((block, index) => {
		const holder = block.querySelector('.if__holder');
		const inner = block.querySelector('.if__inner');
		if(!holder) return;

		const BASE = 'https://vimeo.com/api/oembed.json?url='
		const videoUrl = block.getAttribute('data-url');

		if(videoUrl){
			let url = BASE + videoUrl;
			fetch(url)
				.then((response) => {
					return response.json();
				}).then((data) => {
					// console.log(data);
					let w = data.width;
					let h = data.height;
					let aspect = h / w;
					let wrapperPadding = aspect * 100 + '%';
					holder.style.paddingTop = wrapperPadding;


					let aspectReverse = w / h;
					inner.style.aspectRatio = aspectReverse;

					let blockAspectReverse = block.offsetWidth / block.offsetHeight;
					

					if(aspectReverse<blockAspectReverse) {
						block.classList.remove('is-height-full');
						block.classList.add('is-width-full');
						// console.log('is-width-full')
					} else {
						block.classList.remove('is-width-full');
						block.classList.add('is-height-full');
						// console.log('is-height-full')
					}
					// console.log(data.html);

					window.addEventListener('resize', () => {
						let isVideoFullWidth = compareAspectRatios(holder, block)
						// console.log({isVideoFullWidth});

						if(isVideoFullWidth) {
							block.classList.remove('is-width-full');
							block.classList.add('is-height-full');
							// console.log('is-height-full')
						} else {
							block.classList.remove('is-height-full');
							block.classList.add('is-width-full');
							// console.log('is-width-full')
						}
					});
					
					

					let iframeEl = createIframe(data.html);
					holder.appendChild(iframeEl);
				});
		}
	});

	function compareAspectRatios(el1, el2) {
		const el1Ratio = el1.offsetWidth / el1.offsetHeight;
		const el2Ratio = el2.offsetWidth / el2.offsetHeight;

		return el1Ratio > el2Ratio;
	}

	function createIframe(srcString) {
		srcString = srcString.replace('allowfullscreen', '');

		const parser = new DOMParser();
		const doc = parser.parseFromString(srcString, 'text/html');
		const iframeElement = doc.querySelector('iframe');

		iframeElement.removeAttribute('width');
		iframeElement.removeAttribute('height');

		const currentSrc = iframeElement.getAttribute('src');
		const updatedSrc = `${currentSrc}&background=1&dnt=1`;
		iframeElement.setAttribute('src', updatedSrc);
		iframeElement.setAttribute("loading", "lazy");

		return iframeElement;
	}

}